import React from 'react';
import PropTypes from 'prop-types';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { NON_NUMERIC } from 'Components/UI/MaskedInput';

const PhoneNumberField = ({ attr, onChange, ...rest }) => {
  const { handleChange } = useMetaLayoutContext();

  const replaceAndChange = (value) => {
    const cleanValue = value.replace(NON_NUMERIC, '');
    handleChange(attr, cleanValue);
    return onChange?.call(onChange, cleanValue);
  };

  return <MetaField attr={attr} onChange={replaceAndChange} {...rest} />;
};

PhoneNumberField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default PhoneNumberField;
